import { render, staticRenderFns } from "./GridPage.vue?vue&type=template&id=29f8cc74"
import script from "./GridPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports